<script setup>
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const router = useRouter()
const auth = useAuthStore()

const roleLabelMap = {
  admin: 'ผู้ดูแลระบบ',
  finance: 'เจ้าหน้าที่การเงิน',
  user: 'ลูกบ้าน',
}
</script>

<template>
  <div
    class="min-vh-100 d-flex align-items-center justify-content-center"
    style="background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)"
  >
    <div class="text-center px-4" style="max-width: 480px">
      <!-- Icon -->
      <div class="unauthorized-icon mx-auto mb-4">
        <i class="bi bi-shield-lock"></i>
      </div>

      <!-- Text -->
      <h2 class="fw-bold mb-2">ไม่มีสิทธิ์เข้าถึง</h2>
      <p class="text-muted mb-4">
        คุณไม่มีสิทธิ์เข้าถึงหน้านี้<br />
        กรุณาติดต่อผู้ดูแลระบบ
      </p>

      <!-- Role info -->
      <div class="alert alert-light border rounded-4 d-inline-block px-4 py-2 mb-4 small">
        <i class="bi bi-person-badge me-2 text-primary"></i>
        สิทธิ์ปัจจุบันของคุณ :<strong class="mx-1 fw-bold">{{ roleLabelMap[auth.user?.role] ?? auth.user?.role ?? '-' }}</strong>
      </div>

      <!-- Actions -->
      <div class="d-flex gap-2 justify-content-center">
        <button class="btn btn-secondary border rounded-3" @click="router.back()">
          <i class="bi bi-arrow-left me-1"></i>ย้อนกลับ
        </button>
        <button class="btn btn-primary rounded-3" @click="router.push('/dashboard')">
          <i class="bi bi-speedometer2 me-1"></i>Go To Dashboard
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.unauthorized-icon {
  width: 96px;
  height: 96px;
  border-radius: 28px;
  background: rgba(220, 53, 69, 0.1);
  color: #dc3545;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2.5rem;
}
</style>
